
export const selectCommodityAnalyticsSummaryState = (state) =>
  state.commodityAnalyticsSummary || {};

export const selectSummaryData = (state) =>
  selectCommodityAnalyticsSummaryState(state).data || [];

export const selectLoading = (state) =>
  selectCommodityAnalyticsSummaryState(state).loading || false;

export const selectTotalCommodities = (state) =>
  selectCommodityAnalyticsSummaryState(state).totalCommodities || 0;

export const selectAvgCompletion = (state) =>
  selectCommodityAnalyticsSummaryState(state).avgCompletionScore || 0;

export const selectSavedFilters = (state) =>
  selectCommodityAnalyticsSummaryState(state).savedFilters || {};